export default {
  example: {
    test: 'Language Test'
  }
}